import _ from "lodash";

export const getListUserDataByUKey = (listUser, users) => {
  return users.map((user) => {
    return _.find(listUser, { ukey: user });
  });
};
